// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"695":"5bccddc0","742":"65c0f3f1"}[chunkId] + ".chunk.css";
};